import { useTranslation } from 'react-i18next';
import type { Schemas } from '../../shared/api/client';
import { Pill, StatusDot } from '../../shared/ui';

export function SymbolPill({ symbol }: { symbol: string }) {
  return <Pill strong>{symbol}</Pill>;
}

const STATUS_DOT = {
  open: null,
  target_reached: 'good',
  closed: null,
  cancelled: null,
} as const;

export function PositionStatusPill({
  status,
  triggered = 0,
}: {
  status: Schemas['PositionOut']['status'];
  triggered?: number;
}) {
  const { t } = useTranslation();
  if (status === 'open' && triggered > 0) {
    return (
      <Pill icon={<StatusDot status="warning" />}>
        {t('position.status.buy', { count: triggered })}
      </Pill>
    );
  }
  const dot = STATUS_DOT[status];
  return (
    <Pill icon={dot ? <StatusDot status={dot} /> : undefined}>
      {t(`position.status.${status}`)}
    </Pill>
  );
}
